import { useEffect, useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { fetchOrganisationen } from "@/lib/api"
import { FinanzenSection } from "@/components/FinanzenSection"
import { EmptyState } from "@/components/EmptyState"
import { Select } from "@/components/ui"

/**
 * Finanzen-Modul (Nav-Punkt, nur Rolle `app:stammdaten:finanzen`) — AP-2.9.
 * Zahlungskonditionen/Bankkonten sind je Organisation gepflegt; diese Seite
 * ist der Einstieg über eine Organisationsauswahl (die Fachdaten selbst
 * liegen bereits in `FinanzenSection`, identisch zum Org-Detail-Tab).
 */
export function FinanzenPage() {
  useEffect(() => {
    document.title = "Finanzen — RMNC Stammdaten"
  }, [])

  const [organisationId, setOrganisationId] = useState("")

  const { data: organisationen, isLoading } = useQuery({
    queryKey: ["organisationen", "finanzen-auswahl"],
    queryFn: () => fetchOrganisationen({ size: 500 }),
  })

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-slate-900">Finanzen</h1>
        <p className="text-sm text-slate-600">
          Zahlungskonditionen und Bankverbindungen je Organisation (Ninox `AF`/`BE`/`BF`) —
          AP-2.9. Sichtbar nur mit der Rolle <code>app:stammdaten:finanzen</code>.
        </p>
      </header>

      <div className="mb-6 max-w-sm">
        <label className="mb-1 block text-sm font-medium text-slate-700">Organisation</label>
        <Select
          value={organisationId}
          onChange={(e) => setOrganisationId(e.target.value)}
          disabled={isLoading}
        >
          <option value="">— Organisation auswählen —</option>
          {organisationen?.data.map((o) => (
            <option key={o.id} value={o.id}>
              {o.name}
            </option>
          ))}
        </Select>
      </div>

      {organisationId ? (
        <FinanzenSection organisationId={organisationId} />
      ) : (
        <EmptyState text="Bitte zuerst eine Organisation auswählen, um Zahlungskonditionen und Bankverbindungen zu pflegen." />
      )}
    </div>
  )
}
